import React, { useEffect } from "react";
import Container from "../../component/ui/container";
import FileUpload from "../../component/ui/drag-drop-file";
import { useDispatch } from "react-redux";
import { loaderSet } from "../../context/actions/loaderAction";


export const UploadData = () => {
  const dispatch=useDispatch()
  useEffect(()=>{
   dispatch(loaderSet(true))
   setTimeout(() => {
    dispatch(loaderSet(false))
   }, 3000);
  },[])
  return (
    <Container>
      <div className="py-8">
        {/* accessiblity fix for silktide issues - H1 heading is semantic */}
        <h1 className="text-2xl text-[#0D215C] font-bold mb-4">Upload Data</h1>
        <p className="mb-6 text-gray-600">Please upload a CSV or Excel file to register suppliers.</p>
        <FileUpload />
        {/* <FileGrid></FileGrid> */}
      </div>
    </Container>
  );
};
